import React, { useEffect } from "react";
import styled from "styled-components";

import { CoePlanIcon, FlexColumn, Typography, BulletCheckList, Button } from "../../../components";
import { COLORS } from "../../../constants";
import { useTrack } from "../../../utils";

import { ContactSalesModal } from "./ContactSalesModal";

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 426px;
  width: 100%;
  height: 100%;
`;

const InfoBox = styled.div`
  background: #fdf2dc;
  border-radius: 4px;
  padding: 8px;
  color: #111215;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 500;
`;

const LogoContainer = styled.div`
  background: linear-gradient(
    103deg,
    #428bfa 0%,
    #a769e6 35.27%,
    #d850b8 60.74%,
    #ff3353 78.38%,
    #ff8121 96.5%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const UpgradeToEnterpriseLimitDataSource: React.FC = () => {
  const track = useTrack();

  useEffect(() => {
    track("upgrade_to_enterprise_screen_viewed", { event_from: "webapp_billing_page" });
  }, []);

  const [showContactSalesModal, setShowContactSalesModal] = React.useState(false);

  return (
    <Layout>
      <FlexColumn gap={2} padding={"40px"}>
        <Typography variant={"h4"} fontWeight={"bold"}>
          Contact Sales to Upgrade
        </Typography>
        <Typography variant={"body1"} fontWeight={300}>
          Upgrade your plan to connect to more QuickBooks accounts
        </Typography>

        <InfoBox>You currently have more than 3 QuickBooks accounts connected</InfoBox>

        <BulletCheckList
          items={[
            <Typography variant={"body2"}>Connect unlimited data sources</Typography>,
            <Typography variant={"body2"}>Admin controls & user permissions</Typography>,
            <Typography variant={"body2"}>For teams with 5+ users</Typography>,
            <Typography variant={"body2"}>Unlimited run usage + much more</Typography>,
          ]}
        ></BulletCheckList>

        <Button
          type={"primary"}
          style={{ maxWidth: "180px", marginTop: "20px" }}
          onClick={() => {
            track("contact_sales_button_clicked", { event_from: "webapp_billing_page" });
            track("contact_sales_modal_shown", { event_from: "webapp_billing_page" });
            setShowContactSalesModal(true);
          }}
        >
          Contact Sales
        </Button>
      </FlexColumn>
      <LogoContainer>
        <CoePlanIcon height={88} width={76} fill={COLORS.white} />
      </LogoContainer>
      <ContactSalesModal
        onCancel={() => setShowContactSalesModal(false)}
        showModal={showContactSalesModal}
      />
    </Layout>
  );
};
